import { AfterViewInit, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { StringFormatPipe } from '@app/shared/pipes/stringFormat.pipe';
//import { DbmAutocompleteComponent } from '../../dialogs/dbm-autocomplete/dbm-autocomplete.component';
//import { consts } from '@src/constants/consts';
import { IACOption } from '@src/app/shared/components/dialogs/dbm-autocomplete/dbm-autocomplete.component';
    


@Component({
    selector: 'dbm-table',
    template: require('./dbm-table.component.html'),
    styles: [require('./dbm-table.component.scss')]
})
export class DbmTableComponent implements OnInit, AfterViewInit{

    @Input() public dataSource: any = [];
    @Input() public displayedColumns: any[] = [];
    @Output() public addRowEvent: EventEmitter<any> = new EventEmitter<any>();
    @Output() public removeRowEvent: EventEmitter<any> = new EventEmitter<any>();
    @Output() public selectedValue: EventEmitter<any> = new EventEmitter<any>();
    public isRowAdded: boolean = false;
    public acList: IACOption[] = [];

    constructor(private stringFormatPipe: StringFormatPipe) {
    }

    private firstOpen: boolean = true;

    public ngOnInit(): void {
        this.displayedColumns.map((item) => {
            if (!item.key) {
                item.key = this.stringFormatPipe.transformStr(item.name);
            }
        });
    }

    public ngAfterViewInit(): void {
        this.firstOpen = false;
    }

    public removeRow(element: any): void {
        this.removeRowEvent.emit(element);
    }

    public addRow(event, value): void {
        const result = {};
        if (value.type === 'Textbox') {
            if (event.target.value && event.target.value.length > 0) {
                result[value.key] = event.target.value;
                event.target.value = '';
                this.addRowEvent.emit(result);
                this.isRowAdded = true;
            }
        }
        if (value.type === 'Switch') {
            result[value.key] = event.checked;
            event.source._checked = true;
            this.addRowEvent.emit(result);
        }
        if (value.type === 'Combobox') {
            if (this.firstOpen) {
                return;
            }
            result[value.key] = event;
            this.addRowEvent.emit(result);
        }
        if (value.type === 'Autocomplete') {
            if (this.firstOpen) {
                return;
            }
            result[value.key] = event;
            this.addRowEvent.emit(result);
        }
    }

    public selectValue(event: string, element: any, item: any): void {
        this.selectedValue.emit({ event, element, item });

    }

    public getPlaceholder(item, element) {    
        return element[item.key];
        //return item.list[item.list.indexOf(element[item.key])];   
        //return item.list[(element[item.key])];

    }

    public getDefaultPlaceholder(item) {
        return item.placeholder ? item.placeholder : item.list[0];
    }

    public setFocus(pos) {
        if (this.isRowAdded) {
            this.isRowAdded = false;
            const element = (<HTMLInputElement>document.querySelector(`input[tabindex="${pos + this.dataSource.length * this.displayedColumns.length}"]`));
            if (element) {
                element.focus();
            }
        }
    }
    public getList(item, element)
    {
        try
        {
            this.acList = new Array<IACOption>();

            if(!element)
                return this.acList;
            
            var list2Return = null;
            if(element && item.elementList && element[item.elementList])
                list2Return = element[item.elementList];
            else
                list2Return = item.list;

            if(item.type != "Autocomplete")
                return list2Return;

            //if this is an AC element - translate to IACOption
            for (let i = 0; i < list2Return.length ; i++) {
                this.acList.push({id:i,name:list2Return[i]});
            }

            return this.acList;
        }
        catch(error)
        {
            var e = error;
            return e;
        }
        return [];

        //if(element.list != null)
        //    return element.list;
        //return item.list;
    }

    //Autocomplete functions
    onACTextChange(text: any): void {
        text = text;
        
    }
    
    onACSelectedOption(data: IACOption, element, item) {     
        element[item.key] = data.name;   
        this.selectedValue.emit({ data, element, item });
        //need to raise the selection change event
    }    
    
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/shared/components/basic-components/dbm-table/dbm-table.component.ts